import { Link, ListItem, ListItemText } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Skeleton } from '@mui/material';
import React from 'react';
import IGroup from '../Interfaces/IGroup';

const useStyles = makeStyles({
  listItem: {
    padding: '8px 16px',
    borderBottom: '1px solid silver',
  },
  name: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 600,
    color: '#0066cc',
  },
});

interface IGroupListItem {
  group: IGroup;
}

export const GroupListItemSkeleton = () => {
  const classes = useStyles();

  return (
    <ListItem disableGutters button className={classes.listItem}>
      <ListItemText primary={<Skeleton width={200} />} disableTypography />
    </ListItem>
  );
};

const GroupListItem = (props: IGroupListItem) => {
  const classes = useStyles();
  return (
    <ListItem disableGutters className={classes.listItem}>
      <ListItemText
        primary={
          <Link
            href={`/beacon/students/group/${props.group.id}`}
            variant="h3"
            aria-label={`Go To ${props.group.name}`}
            className={classes.name}
          >
            {props.group.name}
          </Link>
        }
        disableTypography
      />
    </ListItem>
  );
};
export default GroupListItem;
